module.exports = __webpack_public_path__ + "img/serve2.f2e84ddb.png";